module.exports = __webpack_public_path__ + "media/images/ui__themeToggleDark--dark-fd29ad678dcb7371d1f26a63755dcb6a.png";